export default "__VITE_ASSET__d6268475__"